export const DEFAULT_PAGE_INFO = {
  current: 1,
  pageSize: 10,
  total: 0,
};
export const DEFAULT_DETAILS_PAGE_INFO = {
  current: 1,
  pageSize: 20,
  total: 0,
};

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 100;
